module.exports = __webpack_public_path__ + "media/Yam.a8091e84.mp3";